export default "__VITE_ASSET__OTLUQpHr__"